import { get, post, put, del } from "aws-amplify/api";

import "containers/common/Detail.css";
import SLMEntityLinkList from "containers/slm/shared/SLMEntityLinkList";
import SLMOwnerLinkList from "containers/slm/shared/SLMOwnerLinkList";
import SLMReferencesPanel from "containers/slm/shared/SLMReferencesPanel";
import SLMPropertyAttributesPanel from "containers/slm/sale/panels/SLMPropertyAttributesPanel";
import SLMSaleSpecificsPanel from "containers/slm/sale/panels/SLMSaleSpecificsPanel";
import SLMRecordDeliverPanel from "containers/slm/shared/SLMRecordDeliverPanel";
import SLMHistoryPanel from "containers/slm/shared/SLMHistoryPanel";
import { createElementIdFactory } from "utils/elementIds";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Form, Row, Modal, Alert, Nav } from "react-bootstrap";
import { PacmanLoader } from "react-spinners";
import { LinkContainer } from "react-router-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import SLMPropertyAddressPanel from "containers/slm/shared/SLMPropertyAddressPanel";
import SLMBrowsePager from "containers/slm/shared/SLMBrowsePager";

const goLive = new Date("09 May 2023");

export default function SLMSaleDetail(props) {
  const routeLocation = useLocation();
  const routeNavigate = useNavigate();
  const routeParams = useParams();
  const createId = useMemo(() => createElementIdFactory("slm-sale-detail"), []);

  const initialPath = routeLocation?.pathname ?? "";
  const initialPathMatch = initialPath.match(/\/slmsales\/([^/?#]+)/i);
  const initialSaleIdParam = routeParams?.id ?? (initialPathMatch ? decodeURIComponent(initialPathMatch[1]) : null);
  const parsedInitialSaleId = Number.parseInt(initialSaleIdParam, 10);
  const initialSaleId = Number.isNaN(parsedInitialSaleId) ? null : parsedInitialSaleId;

  const [state, setStateInternal] = useState({
    titleDetailsSaved: false,
    volumeFoliosSaved: false,

    isLoading: null,
    isDeleting: null,
    sale: null,
    modified: false,
    showAlert: false,
    errorMessage: "",

    idList: [],
    integrations: [],

    addressFilter: { addressid: -1 },
    agencyFilter: { saleid: initialSaleId, leaseid: null, agentname: null },
    ownerFilter: { saleid: initialSaleId, leaseid: null, ownername: null },

    selectedSourceCategories1: null,
    selectedSourceCategories2: null,
    selectedSourceCategories3: null,
    selectedStatusCategories: null,
    selectedSpaceUseCategories: null,
    selectedBroadSpaceUseCategories: null,
    selectedZoningCategories: null,
    selectedQualityTypeCategories: null,
    selectedTitleBasisCategories: null,
    selectedSaleMethodCategories: null,
    selectedSaleDescriberCategories: null,
    selectedIncomeBasisCategories: null,
    selectedAreaBasisCategories: null,
    selectedCarSpaceCategories: null,

    selectedSuburb: null,
    suburbOptions: [],
    entityLinks: [],
    ownerLinks: [],
    agencyOptions: [],
    agencies: [],
    agents: [],

    showAgencyDialog: false,
    saveForm: false,

    sale_id: null,
    hard_sequence: null,
    address_id: null,
    address_hard_sequence: null,
    source_cat_1: null,
    source_cat_1_id: null,
    source_date_1: null,
    source_page_1: null,
    source_cat_2: null,
    source_cat_2_id: null,
    source_date_2: null,
    source_page_2: null,
    source_cat_3: null,
    source_cat_3_id: null,
    source_date_3: null,
    source_page_3: null,
    print_month: null,
    prev_delivery: null,
    stat_date: null,
    sale_date: null,
    vg_trans_date: null,
    sale_price: null,
    net_income: null,
    floors: null,
    frontage: null,
    percent_sold: null,
    estimated: null,
    sale_yield: null,
    cars: null,
    complete_year: null,
    refurb_year: null,
    floor_area: null,
    floor_space_ratio: null,
    site_area: null,
    sale_status: null,
    status_cat_id: null,
    zoning: null,
    zoning_cat_id: null,
    title_basis: null,
    title_basis_cat_id: null,
    sale_type: null,
    sale_method: null,
    sale_method_cat_id: null,
    sale_describer: null,
    sale_describer_cat_id: null,
    income_basis: null,
    income_basis_cat_id: null,
    area_basis: null,
    area_basis_cat_id: null,
    car_space_describer: null,
    car_space_descr_cat_id: null,
    space_use_name: null,
    space_use_id: null,
    broad_space_use_id: null,
    broad_space_use_code: null,
    purchaser: null,
    vendor: null,
    vg_purchaser: null,
    vg_vendor: null,
    agent: null,
    agency: null,
    mortgagee: null,
    pending: null,
    foreign_investment: null,
    editors_note: null,
    note_data: null,
    sales_notes: null,
    sales_notes_computed: null,
    note_data_id: null,
    quality_type: null,
    quality_type_id: null,
    building_name: null,
    floor_unit: null,
    street_no_low: null,
    street_no_high: null,
    street_name: null,
    extension: null,
    suburb: null,
    state_code: null,
    postcode: null,
    street_address_full: null,
    transfer_number: null,
    unit_number: null,

    created_date: null,
    created_by: null,
    last_edited_date: null,
    last_edited_by: null,
    archived_date: null,

    titleDetails: [],
    showTitleDetailsDialog: false,

    volumeFolios: [],
    showVolumeFoliosDialog: false,

    title_details: null,
    showAddressMatchingDialog: false,
    head_record_property_id: null,
  });

  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  function setState(updater, callback) {
    setStateInternal((prev) => {
      const nextPartial = typeof updater === "function" ? updater(prev) : updater;
      const next = { ...prev, ...(nextPartial || {}) };
      stateRef.current = next;
      return next;
    });

    if (typeof callback === "function") {
      setTimeout(callback, 0);
    }
  }

  function getRouteSaleId() {
    const directId = routeParams?.id;
    if (directId) {
      return directId;
    }

    const pathname = routeLocation?.pathname ?? window?.location?.pathname ?? "";
    const pathMatch = pathname.match(/\/slmsales\/([^/?#]+)/i);
    return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
  }

  function getRouteState() {
    return routeLocation?.state ?? null;
  }

  function getCurrentSaleId() {
    const routeSaleId = getRouteSaleId();
    const parsedSaleId = Number.parseInt(routeSaleId, 10);
    return Number.isNaN(parsedSaleId) ? null : parsedSaleId;
  }

  function getEffectiveSaleId() {
    const routeSaleId = getRouteSaleId();
    const stateSaleId = stateRef.current?.sale_id;
    return stateSaleId || (routeSaleId && routeSaleId !== "new" ? routeSaleId : null);
  }

  function getBrowseIdList(currentSaleId) {
    const routeState = getRouteState();
    if (Array.isArray(routeState?.data)) {
      try {
        sessionStorage.setItem("slm-sale-browse-ids", JSON.stringify(routeState.data));
      } catch (error) {
        // Ignore storage failures and rely on in-memory route state.
      }
      return routeState.data;
    }

    try {
      const stored = sessionStorage.getItem("slm-sale-browse-ids");
      if (!stored) {
        return [];
      }

      const parsed = JSON.parse(stored);
      if (!Array.isArray(parsed)) {
        return [];
      }

      const normalized = parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id));
      if (!Number.isFinite(currentSaleId) || normalized.includes(currentSaleId)) {
        return normalized;
      }

      return [];
    } catch (error) {
      return [];
    }
  }

  function pushRoute(to, routeState) {
    if (typeof to === "string") {
      routeNavigate(to, routeState ? { state: routeState } : undefined);
      return;
    }

    if (to?.pathname) {
      routeNavigate(to.pathname, to.state ? { state: to.state } : undefined);
    }
  }

  function navigateToBrowseSaleRecord(targetId, browseIds = stateRef.current.idList) {
    try {
      sessionStorage.setItem("slm-sale-browse-ids", JSON.stringify(browseIds));
    } catch (error) {
      // Ignore storage failures and continue with route state navigation.
    }

    pushRoute({ pathname: `/slmsales/${targetId}`, state: { data: browseIds } });
  }

  function apiRequestOptions(body, queryParams) {
    const options = {};

    if (body !== undefined && body !== null) {
      options.body = body;
    }

    if (queryParams !== undefined && queryParams !== null) {
      options.queryParams = queryParams;
    }

    return Object.keys(options).length > 0 ? options : undefined;
  }

  async function apiGet(path, queryParams = null) {
    const response = await get({
      apiName: "colin",
      path,
      options: apiRequestOptions(undefined, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  }

  async function apiPost(path, body = null, queryParams = null) {
    const response = await post({
      apiName: "colin",
      path,
      options: apiRequestOptions(body, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  }

  async function apiPut(path, body = null, queryParams = null) {
    const response = await put({
      apiName: "colin",
      path,
      options: apiRequestOptions(body, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  }

  async function apiDel(path, queryParams = null) {
    const response = await del({
      apiName: "colin",
      path,
      options: apiRequestOptions(undefined, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  }

  function formatMoney(value) {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    }).format(value);
  }

  async function getSale() {
    const routeSaleId = getRouteSaleId();
    if (!routeSaleId || routeSaleId === "null" || routeSaleId === "undefined") {
      throw new Error("Missing sale id in route.");
    }
    return apiGet(`/slmsales/${routeSaleId}`);
  }

  async function getEntityLinks(filter) {
    const response = apiGet(`/slmentitylinks`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function getOwnerLinks(filter) {
    const response = apiGet(`/slmownerlinks`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function getAgencies(filter) {
    const response = apiGet(`/slmentities`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function getAgents(filter) {
    const response = apiGet(`/slmagents`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function getOwners(filter) {
    const response = apiGet(`/slmowners`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function getContacts(filter) {
    const response = apiGet(`/slmowners/${filter.orgid}/slmcontacts`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function syncroniseState() {
    const sale = {
      sale_id: stateRef.current.sale_id,
      hard_sequence: stateRef.current.hard_sequence,
      address_id: stateRef.current.address_id,
      address_hard_sequence: stateRef.current.address_hard_sequence,
      source_cat_1: stateRef.current.source_cat_1,
      source_cat_1_id: stateRef.current.source_cat_1_id,
      source_date_1: stateRef.current.source_date_1,
      source_page_1: stateRef.current.source_page_1,
      source_cat_2: stateRef.current.source_cat_2,
      source_cat_2_id: stateRef.current.source_cat_2_id,
      source_date_2: stateRef.current.source_date_2,
      source_page_2: stateRef.current.source_page_2,
      source_cat_3: stateRef.current.source_cat_3,
      source_cat_3_id: stateRef.current.source_cat_3_id,
      source_date_3: stateRef.current.source_date_3,
      source_page_3: stateRef.current.source_page_3,
      print_month: stateRef.current.print_month,
      prev_delivery: stateRef.current.prev_delivery,
      stat_date: stateRef.current.stat_date,
      sale_date: stateRef.current.sale_date,
      vg_trans_date: stateRef.current.vg_trans_date,
      sale_price: stateRef.current.sale_price,
      net_income: stateRef.current.net_income,
      floors: stateRef.current.floors,
      frontage: stateRef.current.frontage,
      percent_sold: stateRef.current.percent_sold,
      estimated: stateRef.current.estimated,
      sale_yield: stateRef.current.sale_yield,
      cars: stateRef.current.cars,
      complete_year: stateRef.current.complete_year,
      refurb_year: stateRef.current.refurb_year,
      floor_area: stateRef.current.floor_area,
      floor_space_ratio: stateRef.current.floor_space_ratio,
      site_area: stateRef.current.site_area,
      sale_status: stateRef.current.sale_status,
      status_cat_id: stateRef.current.status_cat_id,
      zoning: stateRef.current.zoning,
      zoning_cat_id: stateRef.current.zoning_cat_id,
      title_basis: stateRef.current.title_basis,
      title_basis_cat_id: stateRef.current.title_basis_cat_id,
      sale_type: stateRef.current.sale_type,
      sale_method: stateRef.current.sale_method,
      sale_method_cat_id: stateRef.current.sale_method_cat_id,
      sale_describer: stateRef.current.sale_describer,
      sale_describer_cat_id: stateRef.current.sale_describer_cat_id,
      income_basis: stateRef.current.income_basis,
      income_basis_cat_id: stateRef.current.income_basis_cat_id,
      area_basis: stateRef.current.area_basis,
      area_basis_cat_id: stateRef.current.area_basis_cat_id,
      car_space_describer: stateRef.current.car_space_describer,
      car_space_descr_cat_id: stateRef.current.car_space_descr_cat_id,
      space_use_name: stateRef.current.space_use_name,
      space_use_id: stateRef.current.space_use_id,
      broad_space_use_id: stateRef.current.broad_space_use_id,
      broad_space_use_code: stateRef.current.broad_space_use_code,
      purchaser: stateRef.current.purchaser,
      vendor: stateRef.current.vendor,
      vg_purchaser: stateRef.current.vg_purchaser,
      vg_vendor: stateRef.current.vg_vendor,
      agent: stateRef.current.agent,
      agency: stateRef.current.agency,
      mortgagee: stateRef.current.mortgagee,
      pending: stateRef.current.pending,
      foreign_investment: stateRef.current.foreign_investment,
      editors_note: stateRef.current.editors_note,
      note_data: stateRef.current.note_data,
      note_data_id: stateRef.current.note_data_id,
      sales_notes: stateRef.current.sales_notes,
      sales_notes_computed: stateRef.current.sales_notes_computed,
      quality_type: stateRef.current.quality_type,
      quality_type_id: stateRef.current.quality_type_id,
      floor_unit: stateRef.current.floor_unit,
      street_no_low: stateRef.current.street_no_low,
      street_no_high: stateRef.current.street_no_high,
      street_name: stateRef.current.street_name,
      extension: stateRef.current.extension,
      suburb: stateRef.current.suburb,
      state_code: stateRef.current.state_code,
      postcode: stateRef.current.postcode,
      street_address_full: stateRef.current.street_address_full,
      transfer_number: stateRef.current.transfer_number,
      unit_number: stateRef.current.unit_number,
      title_details: stateRef.current.title_details,
      created_date: stateRef.current.created_date,
      created_by: stateRef.current.created_by,
      last_edited_date: stateRef.current.last_edited_date,
      last_edited_by: stateRef.current.last_edited_by,
      archived_date: stateRef.current.archived_date,
    };
    setState({ sale });
  }

  async function saveSale(sale) {
    setState({ last_edited_by: props.user });
    const routeSaleId = getRouteSaleId();
    if (routeSaleId === "new" && stateRef.current.sale_id === null) {
      setState({ created_by: props.user });
      const response = await apiPost(`/slmsales/new`, sale);
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }

    const effectiveSaleId = getEffectiveSaleId();
    if (!effectiveSaleId) {
      throw new Error("Missing sale id for update.");
    }

    const response = apiPut(`/slmsales/${effectiveSaleId}`, sale);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async function retrieveSale() {
    const sale = await getSale();
    const {
      sale_id,
      hard_sequence,
      address_id,
      address_hard_sequence,
      source_cat_1,
      source_cat_1_id,
      source_date_1,
      source_page_1,
      source_cat_2,
      source_cat_2_id,
      source_date_2,
      source_page_2,
      source_cat_3,
      source_cat_3_id,
      source_date_3,
      source_page_3,
      print_month,
      prev_delivery,
      stat_date,
      sale_date,
      vg_trans_date,
      sale_price,
      net_income,
      floors,
      frontage,
      percent_sold,
      estimated,
      sale_yield,
      cars,
      complete_year,
      refurb_year,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      sale_method,
      sale_method_cat_id,
      sale_describer,
      sale_describer_cat_id,
      income_basis,
      income_basis_cat_id,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      purchaser,
      vendor,
      vg_purchaser,
      vg_vendor,
      agent,
      agency,
      mortgagee,
      pending,
      foreign_investment,
      editors_note,
      note_data,
      note_data_id,
      sales_notes,
      sales_notes_computed,
      quality_type,
      quality_type_id,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      street_address_full,
      transfer_number,
      unit_number,
      title_details,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
    } = sale;

    setState({
      sale,
      sale_id,
      hard_sequence,
      address_id,
      address_hard_sequence,
      source_cat_1,
      source_cat_1_id,
      source_date_1,
      source_page_1,
      source_cat_2,
      source_cat_2_id,
      source_date_2,
      source_page_2,
      source_cat_3,
      source_cat_3_id,
      source_date_3,
      source_page_3,
      print_month,
      prev_delivery,
      stat_date,
      sale_date,
      vg_trans_date,
      sale_price,
      net_income,
      floors,
      frontage,
      percent_sold,
      estimated,
      sale_yield,
      cars,
      complete_year,
      refurb_year,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      sale_method,
      sale_method_cat_id,
      sale_describer,
      sale_describer_cat_id,
      income_basis,
      income_basis_cat_id,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      purchaser,
      vendor,
      vg_purchaser,
      vg_vendor,
      agent,
      agency,
      mortgagee,
      pending,
      foreign_investment,
      editors_note,
      note_data,
      note_data_id,
      sales_notes,
      sales_notes_computed,
      quality_type,
      quality_type_id,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      street_address_full,
      transfer_number,
      unit_number,
      title_details,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
    });
  }

  function loadTitleDetailsRetry() {
    setTimeout(() => {
      getTitleDetails();
    }, 30000);
    setTimeout(() => {
      getTitleDetails();
    }, 60000);
    setTimeout(() => {
      getTitleDetails();
    }, 90000);
  }

  function getVolumeFolios(fromModal = false) {
    try {
      const effectiveSaleId = getEffectiveSaleId();
      if (!effectiveSaleId) {
        return;
      }

      apiGet(`/slmsales/${effectiveSaleId}/volume_folios`, null).then((volumeFolios) => {
        if (fromModal) {
          const updatedVolumeFolios = [...stateRef.current.volumeFolios].map((uvf) => {
            const matchingVf = volumeFolios.find((vf) => vf.volume_folio_id === uvf.volume_folio_id);
            return matchingVf ? matchingVf : uvf;
          });
          setState({ volumeFolios: updatedVolumeFolios });
          return;
        }

        setState({ volumeFolios });
      });
    } catch (e) {
      console.log("Error getting volume folios", e);
    }
  }

  function getTitleDetails() {
    try {
      const effectiveSaleId = getEffectiveSaleId();
      if (!effectiveSaleId) {
        return;
      }

      apiGet(`/slmsales/${effectiveSaleId}/parcels`, null).then((titleDetails) => {
        const nextTitleDetails = Array.isArray(titleDetails) ? [...titleDetails] : [];
        const nextStateCode = stateRef.current.state_code;

        if (["NSW", "QLD", "SA", "VIC", "WA"].includes(nextStateCode)) {
          nextTitleDetails.sort((a, b) => a.plan_number - b.plan_number || a.lot_number - b.lot_number);
        } else if (["ACT"].includes(nextStateCode)) {
          nextTitleDetails.sort((a, b) => a.block - b.block || a.section - b.section);
        }

        setState({ titleDetails: nextTitleDetails });
        updateTitleDetailsString();
      });
    } catch (e) {
      console.log("Error getting parcels:", e);
    }
  }

  async function getIntegrations() {
    const effectiveSaleId = getEffectiveSaleId();
    if (!effectiveSaleId) {
      return;
    }

    const response = await apiGet(`/slmsales/${effectiveSaleId}/integrations`);
    setState({ integrations: response });
  }

  async function updateTitleDetailsString() {
    const response = await getSale();
    setState({ title_details: response.title_details, sales_notes_computed: response.sales_notes_computed });
  }

  async function cloneSaleParcels(clonedSaleId, newSaleId = null) {
    if (newSaleId && stateRef.current.titleDetails) {
      const parcels = stateRef.current.titleDetails.map((p) => ({ ...p, sale_id: newSaleId }));
      await apiPost(`/slmsales/${newSaleId}/parcels_bulk/null`, parcels);
      return;
    }

    const parcels = await apiGet(`/slmsales/${clonedSaleId}/parcels`);
    for (const parcel of parcels) {
      parcel.parcel_id = null;
      parcel.sale_id = null;
      parcel._cloned = true;
    }
    setState({ titleDetails: parcels });
  }

  async function cloneSaleVolumeFolios(clonedSaleId, newSaleId = null) {
    if (newSaleId && stateRef.current.volumeFolios) {
      const volumeFolios = stateRef.current.volumeFolios.map((vf) => ({ ...vf, sale_id: newSaleId }));
      await apiPost(`/slmsales/${newSaleId}/volume_folios_bulk/null`, volumeFolios);
      return;
    }

    const volumeFolios = await apiGet(`/slmsales/${clonedSaleId}/volume_folios`);
    for (const volumeFolio of volumeFolios) {
      volumeFolio.volume_folio_id = null;
      volumeFolio.sale_id = null;
    }
    setState({ volumeFolios });
  }

  async function cloneSaleIntegrations(clonedSaleId, newSaleId = null) {
    if (newSaleId && stateRef.current.integrations) {
      const integrations = stateRef.current.integrations.map((integration) => ({ ...integration, sale_id: newSaleId }));
      await apiPost(`/slmsales/${newSaleId}/integrations_bulk/null`, integrations);
      return;
    }

    const integrations = await apiGet(`/slmsales/${clonedSaleId}/integrations`);
    for (const integration of integrations) {
      integration.integration_id = null;
      integration.sale_id = null;
    }
    setState({ integrations });
  }

  async function cloneSale() {
    const sale = getRouteState()?.clone;
    if (!sale) {
      return;
    }

    const {
      address_id,
      address_hard_sequence,
      frontage,
      percent_sold,
      cars,
      complete_year,
      refurb_year,
      floors,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      quality_type,
      quality_type_id,
      building_name,
      street_address_full,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      unit_number,
      sales_notes,
    } = sale;

    setState({
      sale,
      address_id,
      address_hard_sequence,
      floors,
      frontage,
      cars,
      complete_year,
      refurb_year,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      quality_type,
      quality_type_id,
      street_address_full,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      unit_number,
      sales_notes,
      percent_sold,
      building_name,
    });

    await cloneSaleParcels(sale.sale_id, null);
    await cloneSaleVolumeFolios(sale.sale_id, null);
    await cloneSaleIntegrations(sale.sale_id, null);

    const clonedSale = await apiGet(`/slmsales/${sale.sale_id}`);
    setState({ title_details: clonedSale.title_details, sales_notes_computed: clonedSale.sales_notes_computed });
  }

  function validateSalePrice(price) {
    if (Number.isNaN(Number(price))) {
      price = Number(price.toString().substring(1).replaceAll(",", ""));
    }

    if (Number(price) > 100000000000) {
      const priceString = formatMoney(price);
      const truncatedPrice = formatMoney(Number(price.toString().substring(0, 11)));
      return [
        false,
        `ALERT!: Sale Price is too high. Only a maximum Sale Price of 100 Billion is allowed.\n\nValue entered: ${priceString}. This value has been truncated to: ${truncatedPrice}.\n\nPlease check and correct the Sale Price value entered before leaving this record!`,
      ];
    }

    return [true, ""];
  }

  function validateRelatedRecord(record, set) {
    if (set === "sale") {
      if (stateRef.current.stat_date === null) {
        return [false, "ALERT!:  Stat date is required. This record will not be saved until a Stat Date is entered."];
      }

      if (stateRef.current.space_use_id === null) {
        return [false, "ALERT!: Space use is required. This record will not be saved until a Space Use is selected."];
      }

      if (stateRef.current.quality_type_id === null) {
        return [false, "ALERT!: Quality type is required. This record will not be saved until a Quality Type is selected."];
      }

      if (stateRef.current.sale_method_cat_id === null) {
        return [false, "ALERT!: Sale Method is required. This record will not be saved until a Sale Method is selected."];
      }

      if (stateRef.current.floor_space_ratio && stateRef.current.floor_space_ratio.length > 10) {
        return [false, "Floor space ratio can be a maximum of 10 characters. Please reduce the text entered into that field."];
      }
    }

    return [true, ""];
  }

  async function updateTableState(data, set) {
    setState({ [set]: data });
    return true;
  }

  function saveRecord(record, endpoint, id) {
    record.last_edited_by = props.user;

    if (record.hasOwnProperty("new_record") && record.new_record === true) {
      if (endpoint === "slmTitleDetails") {
        setState({ titleDetailsSaved: true });
        const response = apiPost(`/slmsales/${record.sale_id}/parcels/${record[id] ?? "new"}`, record);
        response.then((result) => {
          if (result?.result === true) {
            getIntegrations();
          }
        });
        return response;
      }

      if (endpoint === "slmVolumeFolios") {
        setState({ volumeFoliosSaved: true });
        return apiPost(`/slmsales/${record.sale_id}/volume_folios/${record[id] ?? "new"}`, record);
      }

      if (endpoint === "slmPropertyIntegrations") {
        const response = apiPost(`/slmsales/${record.sale_id}/integrations/${record[id]}`, record);
        response.then((result) => {
          if (result?.result === true) {
            getTitleDetails();
          }
        });
        return response;
      }

      return apiPost(`/slm${endpoint.toLowerCase()}/new`, record);
    }

    if (endpoint === "slmTitleDetails") {
      setState({ titleDetailsSaved: true });
      const response = apiPut(`/slmsales/${record.sale_id}/parcels/${record[id]}`, record);
      response.then((result) => {
        if (result?.result === true) {
          getIntegrations();
        }
      });
      return response;
    }

    if (endpoint === "slmVolumeFolios") {
      setState({ volumeFoliosSaved: true });
      return apiPut(`/slmsales/${record.sale_id}/volume_folios/${record[id]}`, record);
    }

    if (endpoint === "slmPropertyIntegrations") {
      const response = apiPut(`/slmsales/${record.sale_id}/integrations/${record[id]}`, record);
      response.then((result) => {
        if (result?.result === true) {
          getTitleDetails();
        }
      });
      return response;
    }

    return apiPut(`/slm${endpoint.toLowerCase()}/${record[id]}`, record);
  }

  function deleteRecord(endpoint, params) {
    return apiDel(`/${endpoint}`, params);
  }

  async function saveIntegration(integration) {
    integration.last_edited_date = new Date();
    integration.last_edited_by = props.user;

    loadTitleDetailsRetry();

    const effectiveSaleId = getEffectiveSaleId();
    if (!effectiveSaleId) {
      return integration;
    }

    await apiPut(`/slmsales/${effectiveSaleId}/integrations/${integration.property_integration_id}`, integration);
    return integration;
  }

  async function updateRelatedIntegrations(addressId) {
    return apiPut("/slmsales/integrations/related/new", addressId);
  }

  function acceptIntegration(row) {
    row.original.is_accepted = true;
    row.original.accept_reject_by = props.user;
    saveIntegration(row.original);
    setState((prev) => ({ integrations: [...prev.integrations] }));
  }

  function rejectIntegration(row) {
    row.original.is_accepted = false;
    row.original.accept_reject_by = props.user;
    saveIntegration(row.original);
    setState((prev) => ({ integrations: [...prev.integrations] }));
  }

  async function updateIntegrations() {
    const response = await updateRelatedIntegrations(stateRef.current.address_id);
    if (response?.result !== true && response?.error_message) {
      console.warn(response.error_message);
    }
    await getIntegrations();
  }

  function togglePropertyIntegrationsModal() {
    setState((prevState) => ({ showAddressMatchingDialog: !prevState.showAddressMatchingDialog }));
  }

  function toggleTitleDetailsModal() {
    setState(
      (prevState) => ({ showTitleDetailsDialog: !prevState.showTitleDetailsDialog }),
      () => {
        if (stateRef.current.showTitleDetailsDialog === false && stateRef.current.titleDetailsSaved) {
          setState({ titleDetailsSaved: false });
          updateTitleDetailsString();
        }
      }
    );
  }

  function toggleVolumeFoliosModal() {
    setState(
      (prevState) => ({ showVolumeFoliosDialog: !prevState.showVolumeFoliosDialog }),
      () => {
        if (stateRef.current.showVolumeFoliosDialog === false && stateRef.current.volumeFoliosSaved) {
          setState({ volumeFoliosSaved: false });
          updateTitleDetailsString();
        }
      }
    );
  }

  function updateVendorFields() {
    if (stateRef.current.ownerLinks.filter((e) => e.type === "Vendor" && e.name !== "" && e.name !== null).length > 0) {
      let vendors = stateRef.current.ownerLinks.filter((e) => e.type === "Vendor" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());
      vendors = [...new Set(vendors)];
      const vendorsString = vendors.join("; ");
      setState({ vendor: vendorsString, modified: true }, handleBlur);
    } else if (stateRef.current.vendor) {
      const confirmed = window.confirm("Do you want to clear the Vendor form field?");
      if (confirmed) {
        setState({ vendor: "", modified: true }, handleBlur);
      }
    }

    if (stateRef.current.ownerLinks.filter((e) => e.type === "Buyer" && e.name !== "" && e.name !== null).length > 0) {
      let buyers = stateRef.current.ownerLinks.filter((e) => e.type === "Buyer" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());
      buyers = [...new Set(buyers)];
      const buyersString = buyers.join("; ");
      setState({ purchaser: buyersString, modified: true }, handleBlur);
    } else if (stateRef.current.purchaser) {
      const confirmed = window.confirm("Do you want to clear the Purchaser form field?");
      if (confirmed) {
        setState({ purchaser: "", modified: true }, handleBlur);
      }
    }
  }

  function updateAgencyFields(entityLinksOverride = null) {
    const entityLinks = Array.isArray(entityLinksOverride) ? entityLinksOverride : stateRef.current.entityLinks;

    if (entityLinks.length > 0) {
      let agencies = entityLinks.filter((f) => f.name !== "" && f.name !== null).map((e) => (e.name || "").trimEnd());
      agencies = [...new Set(agencies)];
      const agenciesString = agencies.sort().slice(0, 2).join("; ");

      let agentString = "";
      if (agencies.length === 1) {
        let agents = entityLinks.filter((f) => f.agent_name !== "" && f.agent_name !== null).map((e) => e.agent_name).sort();
        agents = [...new Set(agents)];
        if (agents.length > 0) {
          agentString = agents.join("; ");
        }
      } else {
        for (let x = 0; x < 2; x += 1) {
          let agents = entityLinks.filter((e) => (e.name || "").trimEnd() === agencies[x] && e.agent_name !== "" && e.agent_name !== null).map((e) => e.agent_name).sort();

          if (agents.length > 0 && agents[0] != null && agents[0] !== " ") {
            agentString = (agentString + " " + agencies[x]).trim();
            agents = [...new Set(agents)];
            agentString = agentString + ": " + agents.slice(0, 2).join("; ") + ".";
          }
        }
      }

      setState({ agency: agenciesString, agent: agentString, modified: true }, handleBlur);
    } else {
      setState({ agency: "", agent: "", modified: true }, handleBlur);
    }
  }

  function handleSource1Change(selectedSourceCategories1) {
    if (selectedSourceCategories1) {
      setState({ selectedSourceCategories1, source_cat_1_id: selectedSourceCategories1.value, modified: true }, handleBlur);
    } else {
      setState({ selectedSourceCategories1: { value: null, label: null }, source_cat_1_id: null, modified: true }, handleBlur);
    }
  }

  function handleSource2Change(selectedSourceCategories2) {
    if (selectedSourceCategories2) {
      setState({ selectedSourceCategories2, source_cat_2_id: selectedSourceCategories2.value, modified: true }, handleBlur);
    } else {
      setState({ selectedSourceCategories2: { value: null, label: null }, source_cat_2_id: null, modified: true }, handleBlur);
    }
  }

  function handleSource3Change(selectedSourceCategories3) {
    if (selectedSourceCategories3) {
      setState({ selectedSourceCategories3, source_cat_3_id: selectedSourceCategories3.value, modified: true }, handleBlur);
    } else {
      setState({ selectedSourceCategories3: { value: null, label: null }, source_cat_3_id: null, modified: true }, handleBlur);
    }
  }

  function handleStatusChange(selectedStatusCategories) {
    if (selectedStatusCategories) {
      if (selectedStatusCategories.value === 231) {
        setState({
          selectedStatusCategories,
          status_cat_id: selectedStatusCategories.value,
          quality_type_id: 1,
          selectedQualityTypeCategories: { value: 1, label: "{undefined}" },
          modified: true,
        }, handleBlur);
      } else {
        setState({ selectedStatusCategories, status_cat_id: selectedStatusCategories.value, modified: true }, handleBlur);
      }
    } else {
      setState({ selectedStatusCategories: { value: null, label: null }, status_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleBroadSpaceUseChange(selectedBroadSpaceUseCategories) {
    if (selectedBroadSpaceUseCategories) {
      const selectedSpaceUseCategories = props.spaceusecategoryOptions.filter((r) => r.label.replace("## MISSING CODE ", "").replace(" ##", "") === selectedBroadSpaceUseCategories.label)[0];
      setState({
        selectedBroadSpaceUseCategories,
        selectedSpaceUseCategories,
        broad_space_use_id: selectedBroadSpaceUseCategories.value,
        space_use_id: selectedSpaceUseCategories?.value ?? null,
        modified: true,
      }, handleBlur);
    } else {
      setState({
        selectedBroadSpaceUseCategories: { value: null, label: null },
        broad_space_use_id: null,
        modified: true,
        selectedSpaceUseCategories: { value: null, label: null },
        space_use_id: null,
      }, handleBlur);
    }
  }

  function handleSpaceUseChange(selectedSpaceUseCategories) {
    if (selectedSpaceUseCategories) {
      setState({
        selectedSpaceUseCategories,
        space_use_id: selectedSpaceUseCategories.value,
        broad_space_use_id: selectedSpaceUseCategories.supplementary_details.broad_space_use_id,
        modified: true,
        selectedBroadSpaceUseCategories: {
          value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id,
          label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code,
        },
      }, handleBlur);
    } else {
      setState({ selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null, modified: true }, handleBlur);
    }
  }

  function handleZoningChange(selectedZoningCategories) {
    if (selectedZoningCategories) {
      setState({ selectedZoningCategories, zoning_cat_id: selectedZoningCategories.value, modified: true }, handleBlur);
    } else {
      setState({ selectedZoningCategories: { value: null, label: null }, zoning_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleQualityTypeChange(selectedQualityTypeCategories) {
    if (selectedQualityTypeCategories) {
      setState({ selectedQualityTypeCategories, quality_type_id: selectedQualityTypeCategories.value, modified: true }, handleBlur);
    } else {
      setState({ selectedQualityTypeCategories: { value: null, label: null }, quality_type_id: null, modified: true }, handleBlur);
    }
  }

  function handleTitleBasisChange(selectedTitleBasisCategories) {
    if (selectedTitleBasisCategories) {
      setState({ selectedTitleBasisCategories, title_basis_cat_id: selectedTitleBasisCategories.value, modified: true });
    } else {
      setState({ selectedTitleBasisCategories: { value: null, label: null } });
      setState({ title_basis_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleSaleMethodChange(selectedSaleMethodCategories) {
    if (selectedSaleMethodCategories) {
      const saleType = props.saleTypes.filter((option) => option.value === selectedSaleMethodCategories.value);
      setState({
        selectedSaleMethodCategories,
        sale_method_cat_id: selectedSaleMethodCategories.value,
        sale_type: saleType[0]?.label ?? null,
        modified: true,
      }, handleBlur);
    } else {
      setState({ selectedSaleMethodCategories: { value: null, label: null }, sale_method_cat_id: null, sale_type: null, modified: true }, handleBlur);
    }
  }

  function handleSaleDescriberChange(selectedSaleDescriberCategories) {
    if (selectedSaleDescriberCategories) {
      setState({ selectedSaleDescriberCategories, sale_describer_cat_id: selectedSaleDescriberCategories.value, modified: true }, handleBlur);
    } else {
      setState({ selectedSaleDescriberCategories: { value: null, label: null }, sale_describer_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleIncomeBasisChange(selectedIncomeBasisCategories) {
    if (selectedIncomeBasisCategories) {
      setState({ selectedIncomeBasisCategories, income_basis_cat_id: selectedIncomeBasisCategories.value, modified: true }, handleBlur);
    } else {
      setState({ selectedIncomeBasisCategories: { value: null, label: null }, income_basis_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleAreaBasisChange(selectedAreaBasisCategories) {
    if (selectedAreaBasisCategories) {
      setState({ selectedAreaBasisCategories, area_basis_cat_id: selectedAreaBasisCategories.value, modified: true }, handleBlur);
    } else {
      setState({ selectedAreaBasisCategories: { value: null, label: null }, area_basis_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleCarSpaceChange(selectedCarSpaceCategories) {
    if (selectedCarSpaceCategories) {
      setState({ selectedCarSpaceCategories, car_space_descr_cat_id: selectedCarSpaceCategories.value, modified: true }, handleBlur);
    } else {
      setState({ selectedCarSpaceCategories: { value: null, label: null }, car_space_descr_cat_id: null, modified: true }, handleBlur);
    }
  }

  function handleChange(event) {
    setState({ [event.target.id]: event.target.value.trimStart(), modified: true });
  }

  function handleMoneyChange(event) {
    if (event.target.value !== "") {
      const val = event.target.value;
      const validation = validateSalePrice(val);

      if (validation[0] === false) {
        setState({ errorMessage: validation[1], showAlert: true });
        return;
      }

      setState({ [event.target.id]: val, modified: true });
    } else {
      setState({ [event.target.id]: null, modified: true });
    }
  }

  function handlePercentChange(event) {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    setState({ [event.target.id]: val, modified: true });
  }

  function handleNumberChange(event) {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    setState({ [event.target.id]: val, modified: true });
  }

  function handleNonNegativeNumberChange(event) {
    const fieldId = event.target.name || event.target.id;
    const rawValue = event.target.value;

    if (rawValue === "") {
      setState({ [fieldId]: "", modified: true });
      return;
    }

    const parsedValue = Number.parseInt(rawValue, 10);
    const nextValue = Number.isNaN(parsedValue) ? "" : String(Math.max(0, parsedValue));
    setState({ [fieldId]: nextValue, modified: true });
  }

  function handleDateChange(date, name) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const dt = new Date(date);
    const today = new Date();

    if (name === "print_month" && date) {
      if (new Date(dt.toLocaleDateString("en-AU", options)) < new Date(today.toLocaleDateString("en-AU", options))) {
        alert("Delivery date cannot be earlier than today");
        return;
      }
    }

    if (date) {
      if (name === "sale_date") {
        setState({ stat_date: dt.toLocaleDateString("en-AU", options), modified: true });
      }
      if (name === "vg_trans_date" && !stateRef.current.sale_date) {
        setState({ stat_date: dt.toLocaleDateString("en-AU", options), modified: true });
      }

      setState({ [name]: dt.toLocaleDateString("en-AU", options), modified: true });
    } else {
      if (name === "sale_date" && stateRef.current.vg_trans_date) {
        setState({ stat_date: stateRef.current.vg_trans_date, modified: true });
      }
      if (name === "vg_trans_date" && stateRef.current.sale_date) {
        setState({ stat_date: stateRef.current.sale_date, modified: true });
      }

      setState({ [name]: null, modified: true });
    }
  }

  function handleCheckBoxChange(event) {
    const name = event.target.name;
    setState({ [name]: event.target.checked }, handleBlur);
    setState({ modified: true });
  }

  function handleRedeliver() {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const today = new Date();
    const deliveryDate = new Date(stateRef.current.print_month);

    if (!stateRef.current.print_month) {
      alert("Delivery date cannot be empty");
      return;
    }

    if (today.getDate() === deliveryDate.getDate() && today.getMonth() === deliveryDate.getMonth() && today.getFullYear() === deliveryDate.getFullYear()) {
      alert("Delivery date cannot be today");
      return;
    }

    if (
      (today.getDate() < deliveryDate.getDate() && today.getMonth() === deliveryDate.getMonth() && today.getFullYear() === deliveryDate.getFullYear()) ||
      (today.getMonth() < deliveryDate.getMonth() && today.getFullYear() === deliveryDate.getFullYear()) ||
      today.getFullYear() < deliveryDate.getFullYear()
    ) {
      alert("Delivery date cannot be in the past");
      return;
    }

    setState({ prev_delivery: stateRef.current.print_month, print_month: today.toLocaleDateString("en-AU", options), modified: true }, handleBlur);
  }

  async function updateYield(target) {
    if ((target === "sale_price" || target === "net_income") && stateRef.current.net_income !== null && stateRef.current.sale_price !== null && parseFloat(stateRef.current.sale_price.replace(/[^0-9.]/g, "")) > 0) {
      if (stateRef.current.net_income === "") {
        setState({ sale_yield: "" });
      } else {
        setState({
          sale_yield: (
            (parseFloat(stateRef.current.net_income.replace(/[^0-9.]/g, "")).toFixed(2) /
              (parseFloat(stateRef.current.sale_price.replace(/[^0-9.]/g, "")) || 0)) *
            100
          ).toFixed(2),
        });
      }
    }

    if (target === "unit_number" && stateRef.current.unit_number) {
      alert('Please note: this is to be used only where the record relates to a strata unit. Suite or Level information should not be entered in Unit Number.\n\nTitle Basis will be changed to "Strata Titled".');
      setState({ selectedTitleBasisCategories: { label: "Strata Titled", value: 226 }, title_basis_cat_id: 226, modified: true });
    }

    if (target === "title-basis" && stateRef.current.title_basis_cat_id !== 226 && stateRef.current.unit_number) {
      const clearUnitNumber = window.confirm(`Please note: changing the Title Basis from Strata Titled will result in the Unit Number of ${stateRef.current.unit_number} being cleared. Please click OK to proceed or Cancel to abort.`);

      if (clearUnitNumber) {
        setState({ unit_number: "", modified: true });
        return -1;
      }

      setState({ selectedTitleBasisCategories: { label: "Strata Titled", value: 226 }, title_basis_cat_id: 226, modified: true });
    }

    if (target === "unit_number" && stateRef.current.title_basis_cat_id === 226 && !stateRef.current.unit_number) {
      alert('You have just cleared the Unit Number field. Please check Title Basis is correct as "Strata Titled".');
    }

    return 0;
  }

  async function handleBlur(event) {
    let flag = 0;

    if (event?.target?.value) {
      const localFormatMoney = (value) => formatMoney(parseFloat(value.toString().replace(/[^0-9.]/g, "")).toFixed(2));
      if (event.target.id === "sale_price") {
        setState({ sale_price: localFormatMoney(stateRef.current.sale_price) });
      }
      if (event.target.id === "net_income") {
        setState({ net_income: localFormatMoney(stateRef.current.net_income) });
      }
    }

    if (event?.target?.id) {
      flag = await updateYield(event.target.id);
    }

    if (stateRef.current.modified === true) {
      setState({ showAlert: false, last_edited_by: props.user });
      await syncroniseState();

      const validation = validateRelatedRecord(stateRef.current.sale, "sale");
      if (validation[0] !== true) {
        setState({ errorMessage: validation[1], showAlert: true });
        return;
      }

      if (validation[1] !== "") {
        setState({ errorMessage: validation[1], showAlert: true });
      }

      try {
        setState({ modified: false });

        const routeSaleId = getRouteSaleId();
        if (routeSaleId === "new") {
          setState({ isLoading: true });
          setState({ sale: { ...stateRef.current.sale, _cloned: false } });
        }

        const result = await saveSale(stateRef.current.sale);
        setState({ isLoading: false });

        if (result?.result === false) {
          alert(result.error_message);
          return;
        }

        if (routeSaleId === "new") {
          setState({ sale_id: result.id });

          if (getRouteState()?.clone) {
            await cloneSaleParcels(null, result.id);
            await cloneSaleVolumeFolios(null, result.id);
            await cloneSaleIntegrations(null, result.id);
          }

          pushRoute(`/slmsales/${result.id}`, getRouteState());
          return;
        }

        if ((event && event.target.id === "unit_number") || (event && event.target.id === "title-basis" && stateRef.current.title_basis_cat_id === 226) || flag === -1) {
          setState({ isLoading: true });
          await getIntegrations();
          await getTitleDetails();
          setState({ isLoading: false });
        }

        if (event && event.target.id === "transfer_number") {
          updateTitleDetailsString();
        }
        if (event && event.target.id === "sales_notes") {
          updateTitleDetailsString();
        }
      } catch (e) {
        alert(e);
      }
    }
  }

  async function handleDelete(event) {
    event.preventDefault();

    const confirmed = window.confirm("Are you sure you want to delete this sale?");
    if (!confirmed) {
      return;
    }

    setState({ archived_date: new Date() }, () =>
      syncroniseState().then(async () => {
        const result = await saveSale(stateRef.current.sale);
        if (result?.result === false) {
          alert(result.error_message);
        } else {
          pushRoute(`/slmaddresses/${stateRef.current.address_id}`);
        }
      })
    );
  }

  async function loadSaleDetail() {
    try {
      setState({
        isLoading: true,
        showAlert: false,
        errorMessage: "",
      });

      const routeSaleId = getRouteSaleId();
      const routeState = getRouteState();

      if (!routeSaleId) {
        setState({ isLoading: false, errorMessage: "Missing sale id in route.", showAlert: true });
        return;
      }

      if (routeSaleId === "new") {
        const dt = new Date();
        const today = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`;
        const defaultTitleBasisId = routeState?.floor_unit ? 226 : 225;
        const defaultTitleBasis = routeState?.floor_unit ? "Strata Titled" : "Torrens Titled";

        const routeAddressFields = {
          address_id: routeState?.address_id ?? null,
          address_hard_sequence: routeState?.address_hard_sequence ?? null,
          building_name: routeState?.building_name ?? null,
          floor_unit: routeState?.floor_unit ?? null,
          street_no_low: routeState?.street_no_low ?? null,
          street_no_high: routeState?.street_no_high ?? null,
          street_name: routeState?.street_name ?? null,
          extension: routeState?.extension ?? null,
          suburb: routeState?.suburb ?? null,
          state_code: routeState?.state_code ?? null,
          postcode: routeState?.postcode ?? null,
          street_address_full: routeState?.street_address_full ?? null,
        };

        setState({
          created_date: new Date(),
          created_by: props.user,
          ...routeAddressFields,
          status_cat_id: 229,
          sale_status: "Improved",
          space_use_id: 250,
          space_use_name: "SPACE TYPE UNKOWN",
          title_basis_cat_id: defaultTitleBasisId,
          title_basis: defaultTitleBasis,
          quality_type_id: 11,
          quality_type: "Secondhand",
          stat_date: today,
          pending: false,
          foreign_investment: false,
          estimated: false,
          mortgagee: false,
          percent_sold: 100,
          note_data: " ",
          print_month: today,
          agencyFilter: { saleid: null, leaseid: null, agentname: null },
          ownerFilter: { saleid: null, leaseid: null, ownername: null },
          idList: [],
        });

        if (routeState?.clone) {
          await cloneSale();
        } else {
          await syncroniseState();
        }

        document.title = "New sale record";
      } else {
        await retrieveSale();

        const parsedRouteSaleId = Number.parseInt(routeSaleId, 10);
        const idList = getBrowseIdList(parsedRouteSaleId)
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id));

        const agencyFilter = { saleid: parsedRouteSaleId, leaseid: null, agentname: null };
        const ownerFilter = { saleid: parsedRouteSaleId, leaseid: null, ownername: null };

        setState({
          idList,
          agencyFilter,
          ownerFilter,
        });

        await getVolumeFolios();
        await getTitleDetails();
        await getIntegrations();

        const entityLinks = await getEntityLinks(agencyFilter);
        const ownerLinks = await getOwnerLinks(ownerFilter);

        setState({ entityLinks, ownerLinks });

        document.title = `Sale: ${stateRef.current.sale_id || parsedRouteSaleId || ""}`;
      }

      setState({
        addressFilter: { addressid: stateRef.current.address_id },
        selectedSourceCategories1: { value: stateRef.current.source_cat_1_id, label: stateRef.current.source_cat_1 },
        selectedSourceCategories2: { value: stateRef.current.source_cat_2_id, label: stateRef.current.source_cat_2 },
        selectedSourceCategories3: { value: stateRef.current.source_cat_3_id, label: stateRef.current.source_cat_3 },
        selectedStatusCategories: { value: stateRef.current.status_cat_id, label: stateRef.current.sale_status },
        selectedSpaceUseCategories: { value: stateRef.current.space_use_id, label: stateRef.current.space_use_name },
        selectedBroadSpaceUseCategories: { value: stateRef.current.broad_space_use_id, label: stateRef.current.broad_space_use_code },
        selectedZoningCategories: { value: stateRef.current.zoning_cat_id, label: stateRef.current.zoning },
        selectedQualityTypeCategories: { value: stateRef.current.quality_type_id, label: stateRef.current.quality_type },
        selectedTitleBasisCategories: { value: stateRef.current.title_basis_cat_id, label: stateRef.current.title_basis },
        selectedSaleMethodCategories: { value: stateRef.current.sale_method_cat_id, label: stateRef.current.sale_method },
        selectedSaleDescriberCategories: { value: stateRef.current.sale_describer_cat_id, label: stateRef.current.sale_describer },
        selectedIncomeBasisCategories: { value: stateRef.current.income_basis_cat_id, label: stateRef.current.income_basis },
        selectedAreaBasisCategories: { value: stateRef.current.area_basis_cat_id, label: stateRef.current.area_basis },
        selectedCarSpaceCategories: { value: stateRef.current.car_space_descr_cat_id, label: stateRef.current.car_space_describer },
        isLoading: false,
      });
    } catch (e) {
      alert(e);
      setState({ isLoading: false });
    }
  }

  const routeSaleId = getRouteSaleId();
  useEffect(() => {
    loadSaleDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeSaleId]);

  const currencyFormatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const numberFormatter = new Intl.NumberFormat("en-AU", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <div className="Sale">
      {state.isLoading && (
        <div className="outer-div">
          <div className="sweet-loading inner-div">
            <PacmanLoader
              css="display: block;
                            margin: 0 auto;
                             border-color: red"
              sizeUnit={"px"}
              size={20}
              color={"#e03c31"}
              loading={state.isLoading}
            />
          </div>
        </div>
      )}

      {state.sale && props.isAuthenticated && !state.isLoading && (
        <Form>
          <Modal
            show={state.showAlert && state.sale_id ? true : false}
            onHide={() => {
              setState({ showAlert: !state.showAlert });
            }}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Uh Oh!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Alert variant="danger">{state.errorMessage}</Alert>
            </Modal.Body>
          </Modal>

          {state.showAlert && !state.sale_id && <Alert variant="danger">{state.errorMessage}</Alert>}

          <Row className="g-2 mb-2 align-items-start">
            <Col xs={12} lg={5}>
              <h6>
                Sale Details - {state.sale_type} | {state.stat_date} | {state.sale_price} | {state.building_name || ""} | {state.street_address_full || ""} {state.suburb || ""} {state.state_code || ""} {state.postcode || ""}
              </h6>
            </Col>

            <Col xs={12} lg={3}>
              {state.idList.length > 1 && (
                <SLMBrowsePager
                  idList={state.idList}
                  currentRecordId={getCurrentSaleId()}
                  onNavigate={navigateToBrowseSaleRecord}
                  elementIds={{
                    previousButtonId: createId("nav", "previous", "button"),
                    nextButtonId: createId("nav", "next", "button"),
                    inputId: createId("nav", "record", "input"),
                  }}
                />
              )}
            </Col>

            <Col xs={12} lg={4}>
              <Nav className="justify-content-start justify-content-lg-end flex-wrap gap-1">
                <Nav.Item>
                  <LinkContainer
                    to={{
                      pathname: "/slmsales/new",
                      state: {
                        address_id: state.address_id,
                        address_hard_sequence: state.address_hard_sequence,
                        building_name: state.building_name,
                        floor_unit: state.floor_unit,
                        street_no_low: state.street_no_low,
                        street_no_high: state.street_no_high,
                        street_name: state.street_name,
                        extension: state.extension,
                        suburb: state.suburb,
                        state_code: state.state_code,
                        postcode: state.postcode,
                        street_address_full: state.street_address_full,
                      },
                    }}
                  >
                    <Button variant="primary" type="button" size="sm" className="slm-compact-action-btn">
                      New Sale
                    </Button>
                  </LinkContainer>{" "}
                </Nav.Item>

                <Nav.Item>
                  <a href={`/slmaddresses/${state.address_id}`}>
                    <Button variant="primary" size="sm" type="button" className="slm-compact-action-btn">
                      Back to Address
                    </Button>
                  </a>{" "}
                </Nav.Item>

                <Nav.Item>
                  <Button variant="danger" type="button" onClick={handleDelete} size="sm" className="slm-compact-action-btn">
                    Delete Sale
                  </Button>
                </Nav.Item>
              </Nav>
            </Col>
          </Row>

          <Row id="detail" className="g-2">
            <SLMPropertyAddressPanel
              colProps={{ xs: 12, md: 6, xl: 3 }}
              topCardId="saledetails"
              colinId={state.sale_id}
              pimsId={state.hard_sequence}
              addressId={state.address_id}
              addressHardSequence={state.address_hard_sequence}
              buildingName={state.building_name}
              streetAddressFull={state.street_address_full}
              suburb={state.suburb}
              stateCode={state.state_code}
              postcode={state.postcode}
              editAddressTo={{ pathname: `/slmaddresses/${state.address_id}`, state: { sale_id: state.sale_id } }}
              editAddressButtonId={createId("action", "edit-address", "button")}
              unitNumber={state.unit_number}
              unitNumberInputId={createId("field", "unit-number", "input")}
              onUnitNumberChange={handleChange}
              onUnitNumberBlur={handleBlur}
              onAddressMetaChange={handleChange}
              onAddressMetaBlur={handleBlur}
              titleDetails={state.title_details}
              onTitleDetailsChange={handleChange}
              onCoreLogicEdit={togglePropertyIntegrationsModal}
              onCoreLogicRefresh={updateIntegrations}
              onCoreLogicRefreshTimeout={getIntegrations}
              coreLogicRefreshTimeout={90000}
              coreLogicEditButtonId={createId("action", "edit-integrations", "button")}
              coreLogicRefreshButtonId={createId("action", "refresh-address-match", "button")}
              coreLogicFilter={{ saleid: getCurrentSaleId() }}
              coreLogicIsAuthenticated={props.isAuthenticated}
              coreLogicData={state.integrations}
              coreLogicUpdateTableState={updateTableState}
              coreLogicSaveRecord={saveRecord}
              coreLogicDeleteRecord={deleteRecord}
              coreLogicAcceptIntegration={acceptIntegration}
              coreLogicRejectIntegration={rejectIntegration}
              coreLogicContext="slmsale"
              coreLogicShowModal={state.showAddressMatchingDialog}
              coreLogicModalOnClose={togglePropertyIntegrationsModal}
              coreLogicModalProps={{
                toggleAddressModal: togglePropertyIntegrationsModal,
                user: props.user,
                data: state.integrations,
                validateRelatedRecord,
                streetOptions: state.streetOptions,
                getTitleDetails,
              }}
              parcelsSectionProps={{
                filter: { saleid: state.sale_id },
                isAuthenticated: props.isAuthenticated,
                data: state.titleDetails,
                dataFetch: getTitleDetails,
                updateTableState,
                saveRecord,
                deleteRecord,
                validateRelatedRecord,
                context: "slmsale",
                stateCode: state.state_code,
                showModal: state.showTitleDetailsDialog,
                onEdit: toggleTitleDetailsModal,
                onClose: toggleTitleDetailsModal,
                user: props.user,
                disabled: state.head_record_property_id ? true : false,
                editButtonId: createId("action", "edit-parcels", "button"),
              }}
              volumeFoliosSectionProps={{
                filter: { saleid: getCurrentSaleId() },
                isAuthenticated: props.isAuthenticated,
                data: state.volumeFolios,
                dataFetch: getVolumeFolios,
                updateTableState,
                saveRecord,
                deleteRecord,
                validateRelatedRecord,
                context: "slmsale",
                showModal: state.showVolumeFoliosDialog,
                onEdit: toggleVolumeFoliosModal,
                onClose: toggleVolumeFoliosModal,
                user: props.user,
                disabled: state.head_record_property_id ? true : false,
                editButtonId: createId("action", "edit-volume-folios", "button"),
              }}
            />

            <Col xs={12} md={6} xl={3}>
              <SLMReferencesPanel
                referenceOptions={props.sourcecategoryOptions}
                selectedSourceCategories1={state.selectedSourceCategories1}
                selectedSourceCategories2={state.selectedSourceCategories2}
                selectedSourceCategories3={state.selectedSourceCategories3}
                sourceDate1={state.source_date_1}
                sourceDate2={state.source_date_2}
                sourceDate3={state.source_date_3}
                sourcePage1={state.source_page_1}
                sourcePage2={state.source_page_2}
                sourcePage3={state.source_page_3}
                onSource1Change={handleSource1Change}
                onSource2Change={handleSource2Change}
                onSource3Change={handleSource3Change}
                onDateChange={handleDateChange}
                onPageChange={handleNonNegativeNumberChange}
                onBlur={handleBlur}
                createId={createId}
              />

              <SLMPropertyAttributesPanel
                state={state}
                areaBasisOptions={props.areabasiscategoryOptions}
                carSpaceOptions={props.carspacecategoryOptions}
                qualityTypeOptions={props.qualitytypecategoryOptions}
                zoningOptions={props.zoningcategoryOptions}
                numberFormatter={numberFormatter}
                currencyFormatter={currencyFormatter}
                goLiveDate={goLive}
                onChange={handleChange}
                onBlur={handleBlur}
                onNumberChange={handleNumberChange}
                onAreaBasisChange={handleAreaBasisChange}
                onCarSpaceChange={handleCarSpaceChange}
                onQualityTypeChange={handleQualityTypeChange}
                onZoningChange={handleZoningChange}
                createId={createId}
              />
            </Col>

            <Col xs={12} md={6} xl={3}>
              <SLMSaleSpecificsPanel
                slmLookups={props.slmlookups}
                state={state}
                titleBasisOptions={props.titlebasiscategoryOptions}
                statusOptions={props.statuscategoryOptions}
                broadSpaceUseOptions={props.broadspaceusecategoryOptions}
                detailedSpaceUseOptions={props.spaceusecategoryOptions}
                saleMethodOptions={props.salemethodcategoryOptions}
                saleDescriberOptions={props.saledescribercategoryOptions}
                incomeBasisOptions={props.incomebasiscategoryOptions}
                onTitleBasisChange={handleTitleBasisChange}
                onStatusChange={handleStatusChange}
                onBroadSpaceUseChange={handleBroadSpaceUseChange}
                onSpaceUseChange={handleSpaceUseChange}
                onSaleMethodChange={handleSaleMethodChange}
                onSaleDescriberChange={handleSaleDescriberChange}
                onDateChange={handleDateChange}
                onChange={handleChange}
                onBlur={handleBlur}
                onMoneyChange={handleMoneyChange}
                onCheckBoxChange={handleCheckBoxChange}
                onNumberChange={handleNumberChange}
                onPercentChange={handlePercentChange}
                onIncomeBasisChange={handleIncomeBasisChange}
                createId={createId}
              />
            </Col>

            <Col xs={12} md={6} xl={3}>
              <SLMRecordDeliverPanel state={state} createId={createId} onRedeliver={handleRedeliver} onDateChange={handleDateChange} onBlur={handleBlur} onCheckBoxChange={handleCheckBoxChange} />

              <Card className="mb-2">
                <Card.Header>Agents & Agencies</Card.Header>
                <Card.Body>
                  <Form.Group as={Row} controlId="agent">
                    <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                      Agent
                    </Form.Label>
                    <Col>
                      <Form.Control readOnly={state.entityLinks.length > 0 ? true : false} onChange={handleChange} onBlur={handleBlur} value={state.agent} as="input" type="text" />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="agency">
                    <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                      Agency
                    </Form.Label>
                    <Col>
                      <Form.Control readOnly={state.entityLinks.length > 0 ? true : false} onChange={handleChange} onBlur={handleBlur} value={state.agency} as="input" type="text" />
                    </Col>
                  </Form.Group>

                  <Row>
                    <Col>
                      <SLMEntityLinkList
                        isAuthenticated={props.isAuthenticated}
                        controlType="table2"
                        data={state.entityLinks}
                        updateTableState={updateTableState}
                        saveRecord={saveRecord}
                        deleteRecord={deleteRecord}
                        sale_id={state.sale_id}
                        lease_id={null}
                        user={props.user}
                        state_code={state.state_code}
                        validateRelatedRecord={validateRelatedRecord}
                        getAgencies={getAgencies}
                        getAgents={getAgents}
                        getEntityLinks={getEntityLinks}
                        updateAgencyFields={updateAgencyFields}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card className="mb-2">
                <Card.Header>Buyers & Vendors</Card.Header>
                <Card.Body>
                  <Form.Group as={Row} controlId="purchaser">
                    <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                      Buyer
                    </Form.Label>
                    <Col>
                      <Form.Control onChange={handleChange} onBlur={handleBlur} value={state.purchaser} as="input" type="text" readOnly={state.ownerLinks.filter((f) => f.type === "Buyer").length > 0 ? true : false} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="vendor">
                    <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                      Vendor
                    </Form.Label>
                    <Col>
                      <Form.Control onChange={handleChange} onBlur={handleBlur} value={state.vendor} as="input" type="text" readOnly={state.ownerLinks.filter((f) => f.type === "Vendor").length > 0 ? true : false} />
                    </Col>
                  </Form.Group>

                  <br />
                  <br />
                  <Form.Group as={Row} controlId="vg_purchaser">
                    <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                      VG Buyer
                    </Form.Label>
                    <Col>
                      <Form.Control onChange={handleChange} onBlur={handleBlur} value={state.vg_purchaser} as="input" type="text" />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="vg_vendor">
                    <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                      VG Vendor
                    </Form.Label>
                    <Col>
                      <Form.Control onChange={handleChange} onBlur={handleBlur} value={state.vg_vendor} as="input" type="text" />
                    </Col>
                  </Form.Group>
                  <Row>
                    <Col>
                      <SLMOwnerLinkList
                        isAuthenticated={props.isAuthenticated}
                        controlType="table2"
                        data={state.ownerLinks}
                        updateTableState={updateTableState}
                        saveRecord={saveRecord}
                        deleteRecord={deleteRecord}
                        sale_id={state.sale_id}
                        lease_id={null}
                        user={props.user}
                        state_code={state.state_code}
                        validateRelatedRecord={validateRelatedRecord}
                        getOwners={getOwners}
                        getContacts={getContacts}
                        getOwnerLinks={getOwnerLinks}
                        updateVendorFields={updateVendorFields}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <SLMHistoryPanel state={state} createId={createId} />
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
}
